import { Sort as HeadlessSort } from "@coveo/headless";
import { useEffect, useState } from "react";
import { setBodyPositionFixed } from "utils/dom";
import { SortByDictionary } from "components/coveo-headless/types/coveo-headless-types";

type SortMobileProps = {
	controller: HeadlessSort;
	criteria: SortByDictionary[];
	setMobileSortBy: (criterionName: string) => void;
	setToggleMobileSort: (toggleMobileSort: boolean) => void;
};

const SortMobile = ({
	controller,
	criteria,
	setMobileSortBy,
	setToggleMobileSort,
}: SortMobileProps) => {
	const [, setState] = useState(controller.state);

	useEffect(() => controller.subscribe(() => setState(controller.state)), [controller]);

	return (
		<>
			<div className="coveo-headless-sort-mobile-menu-label">Sort By</div>
			{criteria.map((sortInfo) => (
				<button
					aria-label={`sort by ${sortInfo.name}`}
					className="coveo-headless-sort-mobile-menu-button"
					key={sortInfo.name}
					onClick={() => {
						setBodyPositionFixed();
						setToggleMobileSort(false);
						setMobileSortBy(sortInfo.name);
						controller.sortBy(sortInfo.criterion);
					}}
				>
					{sortInfo.name}
				</button>
			))}
		</>
	);
};

export default SortMobile;
